/* HEIMWEH — Saisonale Darstellung "Lieferung vor Weihnachten"
 *
 * BEFRISTET. NACH WEIHNACHTEN WIEDER ENTFERNEN.
 * Zum Entfernen genuegt es, die eine Script-Zeile in layout/theme.liquid
 * zu loeschen. Diese Datei kann dann stehen bleiben oder mit weg.
 *
 * DAS MOBILE WARENKORB-GITTER — VIER ZUSAMMENHAENGENDE REGELN
 * In assets/mandasa.css liegt der mobile Warenkorb als Gitter:
 *   grid-template-columns: 100px minmax(0, 1fr) auto;
 *   Reihe 1: Bild | Text | X
 *   Reihe 2: Mengenwaehler | — | Preis
 * Die vier Regeln unten gehoeren zusammen. Wird eine davon entfernt,
 * kippt eine der anderen mit.
 *
 * 1) REIHENHOEHE. Der Textblock stand auf grid-row: 1 / span 2. Bei einem
 *    gespannten Element verteilt CSS Grid die ueberschuessige Hoehe auf
 *    ALLE gespannten Reihen — also wuchs auch Reihe 1, und der
 *    Mengenwaehler rutschte je nach Textlaenge unterschiedlich weit unter
 *    das Bild. Jetzt bekommt Reihe 1 GENAU die Bildhoehe, geliefert von
 *    assets/hw-cart-heights.js als --hw-img-h. Der Abstand Bild zu
 *    Mengenwaehler ist damit bei jedem Produkt gleich.
 *
 * 2) TEXTBREITE. Die dritte Spalte steht auf "auto" und richtet sich nach
 *    ihrem breitesten Inhalt. Das war der Preis mit rund 90 Pixeln — und
 *    zwar in BEIDEN Reihen, obwohl in Reihe 1 nur das kleine X steht. Dem
 *    Text fehlte diese Breite, "Lieferung vor Weihnachten" brach um. Jetzt
 *    spannt der Preis die Spalten 2 und 3, bleibt durch justify-self: end
 *    rechtsbuendig, und Spalte 3 schrumpft auf die Breite des X.
 *    OHNE DIESE REGEL BRICHT DER TEXT WIEDER UM.
 *
 * 3) PREIS AUF HOEHE DES MENGENWAEHLERS. Der Preis stand auf
 *    align-self: end und sass an der Unterkante von Reihe 2, bei langem
 *    Text also tiefer. Jetzt startet er oben in Reihe 2 mit demselben
 *    Abstand wie der Mengenwaehler, bekommt dessen Hoehe und richtet
 *    seinen Text unten aus. Beide Unterkanten liegen auf einer Linie.
 *
 * 4) TITEL AM X. Durch Regel 2 ist Spalte 3 nur noch so breit wie das X,
 *    der Titel reicht sonst bis dicht heran. Der Innenabstand haelt die
 *    Ellipse davon weg. Gekuerzt wird immer mit Punkten, nie hart.
 *    Laengster Titel im Shop: "Geschenkgutschein, verschiedene Werte",
 *    36 Zeichen.
 *
 * Laengerer Text laeuft in Spalte 2 nach unten weiter, also neben dem
 * Mengenwaehler. Das ist gewollt und ueberlappt nichts, weil der Preis
 * rechtsbuendig sitzt und die langen Textzeilen links stehen.
 *
 * WARUM ALS SKRIPT UND NICHT IM MARKUP
 * sections/main-cart.liquid ist 62 KB gross und liegt damit ueber dem
 * Limit, das ueber die Shopify Admin API geschrieben werden kann.
 */
(function () {
  var TEXT = 'Lieferung vor Weihnachten';
  var RE = /^\d{1,2}\s*[-–—]\s*\d{1,2}\s*Werktage$/;
  var SCOPES = '.custom--cartitem, cart-item, .cart-item, cart-items, #ctmCartDrawer';
  var CSS = [
    '.hw-xmas{margin-bottom:0 !important;padding-bottom:0 !important;}',
    '.hw-xmas + *{margin-top:0 !important;padding-top:0 !important;}',
    '@media screen and (max-width:767px){',
    '  .hw-xmas + *{margin-top:0.4rem !important;}',
    '  .custom--cartitem{grid-template-rows:var(--hw-img-h,100px) auto !important;}',
    '  .custom--cartitem .cart-item-details > div:nth-child(1){',
    '    grid-row:1 !important;align-self:start !important;}',
    '  .custom--cartitem .cart-item-details > div:nth-child(2){',
    '    align-self:start !important;margin-top:8px !important;}',
    '  .custom--cartitem .cart-item-right .price{',
    '    grid-column:2 / span 2 !important;align-self:start !important;',
    '    margin-top:8px !important;min-height:calc(3.8rem + 2px);',
    '    display:flex;align-items:flex-end;justify-content:flex-end;}',
    '  .custom--cartitem .cart-item-details .product-title{',
    '    padding-inline-end:1.6rem !important;}',
    '}',
    '.announcement-bar .announcement-bar__content,',
    '.announcement-bar .announcement-bar__text{transform:translateX(-6px);}',
    '@media screen and (max-width:749px){',
    '  .announcement-bar .announcement-bar__content,',
    '  .announcement-bar .announcement-bar__text{transform:translateX(-8px);}',
    '}'
  ].join('');
  var timer = null;

  function style() {
    if (document.getElementById('hw-xmas-style')) return;
    var st = document.createElement('style');
    st.id = 'hw-xmas-style';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function run() {
    var scopes = document.querySelectorAll(SCOPES);
    for (var s = 0; s < scopes.length; s++) {
      var nodes = scopes[s].querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.children.length) continue;
        if (el.classList.contains('hw-xmas')) continue;
        if (!RE.test((el.textContent || '').trim())) continue;

        var prev = el.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains('hw-xmas')) continue;

        var line = el.cloneNode(false);
        line.removeAttribute('id');
        line.classList.add('hw-xmas');
        line.textContent = TEXT;
        el.parentNode.insertBefore(line, el);
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 60);
  }

  function boot() {
    style();
    run();
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('cart:updated', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();